import React from 'react'
import { Tour } from 'antd'
import { TOURS_ENABLED } from '../tours-enabled'

type Props = {
  open: boolean
  onClose: () => void
  addButtonTarget: () => HTMLElement
}

export function EnumCollectionOnboardingTour({ open, onClose, addButtonTarget }: Props) {
  if (!TOURS_ENABLED) return null
  return (
    <Tour
      open={open}
      onClose={onClose}
      steps={[
        {
          title: 'Заполните справочник',
          description:
            'Нажмите «Добавить запись» и добавьте хотя бы одно значение. После первого сохранения этот шаг отметится как выполненный.',
          target: () => addButtonTarget() || document.body,
          nextButtonProps: {
            children: 'Понятно',
            onClick: onClose,
          },
        },
      ]}
    />
  )
}
